<header class="page-header-bar">
  <div class="page-header-main">
    @if (icon.length > 0) {
      <button mat-icon-button class="page-header-icon" (click)="iconBtnClicked($event)">
        <mat-icon>{{ icon }}</mat-icon>
      </button>
    }
    <h1 class="page-header-title" (click)="refresh()">{{ pageTitle }}</h1>
    <button mat-icon-button class="page-header-info" matTooltip="About this page" matTooltipPosition="below"
      (click)="openInfo()" aria-label="About this page">
      <mat-icon>info_outline</mat-icon>
    </button>
    @if (selection) {
      <mat-select class="page-header-select" placeholder="Select A Query" name="selection">
        @for (selection of selections; track selection) {
          <mat-option [value]="selection.name" class="text label-text">
            {{ selection.name }}
          </mat-option>
        }
      </mat-select>
    }
  </div>
  <div class="page-header-actions">
    @if (refreshEmit.observed) {
      <button mat-icon-button matTooltip="Refresh" matTooltipPosition="below" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
      </button>
    }
    @if (menuActions.length) {
      <roots-action-menu [items]="menuActions" (onItemClick)="toggleAction($event)"></roots-action-menu>
    }
    @for (action of primaryActions; track action.name) {
      <button mat-flat-button class="page-header-primary" [matTooltip]="action.toolTip" matTooltipPosition="below"
        (click)="toggleAction(action)">
        @if (action.icon) {
          <mat-icon>{{ action.icon }}</mat-icon>
        }
        {{ action.name }}
      </button>
    }
  </div>
  @if (loading) {
    <mat-progress-bar class="page-header-progress" mode="indeterminate"></mat-progress-bar>
  }
</header>
